import { withAPIAccount } from '../../lib/http/api';
import { parsedResponse } from '../../lib/http/http';
import {
  AccountType,
  IAPIresponse,
  ICreateRoleBody,
  IDeleteRoleBody,
  IEditRoleBody,
  IRBACRole,
  IServicePermissions,
} from '../../model';
import { PERMISSION_PREFIX, PERMISSION_PROXY_PREFIX } from '../config';

// 获取角色列表
export const getRolesList = (studioId: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const supportRolePrefix = 'supportAccReq_role';
      const url = `${PERMISSION_PREFIX}/role?studioID=${studioId}`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<ReadonlyArray<IRBACRole>>(
        response,
        'data'
      );
      return res.filter((item) => !item.roleName.startsWith(supportRolePrefix));
    } catch (error) {
      console.log(error);
      return null;
    }
  });

// 删除角色
export const deleteRoles = (roleID: number, body: IDeleteRoleBody) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${PERMISSION_PREFIX}/role/${roleID}`;
      const response = await api.commonRequest('DELETE', url, body);
      const res = await parsedResponse<IAPIresponse>(response, 'data');
      return res;
    } catch (error) {
      console.log(error);
      return null;
    }
  });

// 新建角色
export const createRoles = (body: ICreateRoleBody) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${PERMISSION_PREFIX}/role`;
      const response = await api.commonRequest('POST', url, body);
      const res = await parsedResponse<IAPIresponse>(response, 'data');
      return res;
    } catch (error) {
      console.log(error);
      return null;
    }
  });

// 编辑更新角色
export const editRoles = (roleID: number, body: IEditRoleBody) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${PERMISSION_PREFIX}/role/${roleID}`;
      const response = await api.commonRequest('PUT', url, body);
      const res = await parsedResponse<IAPIresponse>(response, 'data');
      return res;
    } catch (error) {
      console.log(error);
      return null;
    }
  });

// 获取服务权限列表-平铺
export const getServicePermissionsList = () =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      // const url = `${PERMISSION_PREFIX}/role-object`;
      const url = `${PERMISSION_PROXY_PREFIX}/GetObjectList`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<IServicePermissions>(response, 'data');
      return res;
    } catch (error) {
      console.log(error);
      return null;
    }
  });
